import { useCallback, useSyncExternalStore } from "react";

export const phoneQuery = "(max-width: 719px)";

export function useMatches(query: string): boolean {
  const subscribe = useCallback(
    (changed: () => void) => {
      const list = matchMedia(query);
      list.addEventListener("change", changed);
      return () => list.removeEventListener("change", changed);
    },
    [query],
  );
  return useSyncExternalStore(subscribe, () => matchMedia(query).matches);
}
